import notification from '@motionelements/core/src/store/modules/notification.js';

export default {
  namespaced: true,
  state: () => notification.state,
  getters: notification.getters,
  actions: notification.actions,
  mutations: notification.mutations,
};
